import { AppTester, getCurrentContextName } from "supporting";
import { useTeam } from "./useTeam";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

export const EMPTY_CONTENT_TAB = 'EMPTY_CONTENT_TAB';

const TAB_DATA = {
    main: {
        contexts: ['hsedesign'],
        projectFilter: 21,
        projectStatus: [1,6],
        isLite: true,
        mainPage: true,
        limit: 20,
        isFilterReplaceTags: true,
        requestContext: 'design_main',
    },
    mainGeo: {
        projectFilter: 20,
        projectStatus: [1,6],
        isLite: true,
        mainPage: true,
        hasGeoPlaces: true,
        limit: 20,
        isFilterReplaceTags: true,
        requestContext: 'main_geo',
        tagIds: [
            '370972265d64431f9b9a8d1085474ea5',
            'c1e7071d86004544a497fd305b38550d',
            'b233488ebb364517b0acfdece809b3b6',
            '8ba964314ecd4d10b70693f5322605d1',
            '51069562a18341c2a968889727034174',
            '8db18d7413d74ab7a8e7aac29cfa3b25',
            '80f8067e3db745d3985740ccc30d3d5a',
            'd85cb74227a841998fa2aa18843ad35b',
            '977b986e706b46ff9e8b809c700a9c5d'
        ]
    },
    sound: {
        contexts: ['hsedesign'],
        projectFilter: 20,
        projectStatus: [1,6],
        isLite: true,
        mainPage: true,
        limit: 20,
        isFilterReplaceTags: true,
        globalTypes: ['student'],
        requestContext: 'sound_deziiign',
        tagIds: ['30e39c2e27fb430cbe541d94eb32d1ea']
    },
    hsedesign: {
        projectFilter: 20,
        isLite: true,
        limit: 20,
        contexts: ['hsedesign'],
        mainPage: true,
        projectStatus: 1,
        globalTypes: ['student', 'hsealumni'],
        requestContext: 'hsemain',
    },
    lms: {
        projectFilter: 20,
        isLite: true,
        contexts: ['hsecourses'],
        moderationTypes: 3,
        projectStatus: 1,
        requestContext: 'lms'
    },
    lmshse: {
        projectFilter: 3,
        isLite: true,
        limit: 20,
        contexts: ['educationalcourses', 'lmsonlinevaria'],
        moderationTypes: 3,
        globalTypes: ['student', 'hsealumni'],
        projectStatus: 1,
        requestContext: 'educationalcourses',
        lMSCourseType: 0

    },
    dafes: {
        projectFilter: 20,
        projectStatus: [1,6],
        isLite: true,
        mainPage: true,
        requiredTagIds: ['009c939ebdc34eb4801246557e49979f'],
        limit: 20,
        isFilterReplaceTags: true,
        requestContext: 'dafes',
        tagIds: [
            '1b374fc6d2aa4f3696a3558b324bca31',
            'ffa06d1b16b54abba2bbf6c8fb7eaf6d',
            '89412f173a904356beb8e25f74ff2b73',
            '2687fadaf0e048ed9925e56052f3010e',
            '0ea8c1fd2f6e49c3839c29fa10bc93b0',
            '9bbc6e63198244efb2f6e586898f8f84',
            '36e3fd69fede4f9fb4f84d1be90a9e91',
            'f0f14e99db1c4e25b889e87db45a73a0',
            '269d0812d0d84d4ca64faaea4f3b88cc',
            '8972f434446b43c49dd0db38f5e8e376',
            '47ae888ae5fe4343ad29999d04829b44',
            '52644f0d0d9d4a2ea47192e70310ec12',
            '55cc44daca804b979d067f9a59c56e00'
        ]
    },
    art: {
        projectFilter: 20,
        projectStatus: [1,6],
        isLite: true,
        mainPage: true,
        hascities: true,
        limit: 20,
        requestContext: 'art_geo',
        tagIds: [
            '140cdf7r1e3d8aq83e13qwedx14ba',
            '36eb670a9e774a3eba96d0a6e080d064',
            'df140c74barqwe1e3d883a590378812d77',
            'df140c74barqwe1e3d883aqe13dxzd2124dxs1',
            '5164b991a9d8469389175ceeb86d65b8',
            'cd7fbc104946470e872eb12d69343aeb',

        ],
        isContextIgnored: false
    },
    events: {
        hasGeotag: true,
        projectFilter: 20,
        projectStatus: [1,6],
        isLite: true,
        mainPage: true,
        limit: 20,
        isFilterReplaceTags: true,
        requestContext: 'events_geo',
        tagIds: [
            '00a68ac85a0e474985d37136a313f3bb',
            '3859c2a874cd4fcc8982995bc23fffda',
            'e3fdeca5f3aa47f485300ea15eee4e9b',
            'e1422025280f4aee8a6b69ecb78247e4',
            'c0c4895b14e642b4a0fbc471d0d3a35c',
            'd695b64fa924436197197838534cc829',
            '6a8a43782ea04a2192d0418809d3666a'
        ]
    },
    creative: {
        hasGeotag: true,
        projectFilter: 20,
        projectStatus: [1,6],
        isLite: true,
        mainPage: true,
        limit: 20,
        isFilterReplaceTags: true,
        requestContext: 'creative_geo',
        tagIds: ['dc762a78dac54369b91542bcbe86bb2a']
    },
    lmsmediiia: {
        projectFilter: 20,
        isLite: true,
        limit: 20,
        tagIds: [
            'd2d175d64b3b491c812f303fb6db6271'
        ],
        projectStatus: [1],
        requestContext: 'lms'
    },
    awards: {
        contexts: ['main_portfolio'],
        projectFilter: 21,
        projectStatus: [1,6],
        isLite: true,
        mainPage: true,
        limit: 20,
        isFilterReplaceTags: true,
        requestContext: 'main_portfolio',
    },
    game: {
        contexts: ['gamedeziiign'],
        projectFilter: 21,
        projectStatus: [1,6],
        isLite: true,
        mainPage: true,
        limit: 20,
        isFilterReplaceTags: true,
        requestContext: 'gamedeziiign',
    },
    exams: {
        contexts: ['exams2025'],
        projectFilter: 21,
        projectStatus: [1,6],
        isLite: true,
        mainPage: true,
        limit: 20,
        isFilterReplaceTags: true,
        requestContext: 'exams2025',
    },
    fashion: {
        contexts: ['hsedesign'],
        projectFilter: 21,
        projectStatus: [1,6],
        isLite: true,
        mainPage: true,
        limit: 20,
        isFilterReplaceTags: true,
        requestContext: 'fashion',
    },
    hsehh: {
        contexts: ['hsespace'],
        projectFilter: 21,
        projectStatus: [1,6],
        isLite: true,
        mainPage: true,
        limit: 20,
        isFilterReplaceTags: true,
        requestContext: 'hsespace',
    }
}

const getEmptyTabData = () => {
    if (getCurrentContextName() === 'main' && AppTester.isGeograffee()) return TAB_DATA['mainGeo']
    if (['hsesound']?.includes(getCurrentContextName())) return TAB_DATA['hsedesign']
    //@ts-ignore
    return TAB_DATA[getCurrentContextName() as keyof TAB_DATA]
}

const getReplacedCtx = () => {
    const ctx = getCurrentContextName();

    switch (ctx) {
        case 'books': 
            return 'books_deziiign'
        case 'pro':
            return 'prodeziiign'
        case 'academy':
            return 'creativecityacademy'
        case 'creativemediiia':
            return 'mediiiacreative';
        case 'historymediiia':
            return 'mediiiahistory'
        case 'transfermediiia':
            return 'mediiiatransfer'
        case 'profmediiia':
            return 'mediiiaprof'
        case 'cinemediiia':
            return 'mediiiacine'
        case 'aimediiia':
            return 'mediiiaai'
        case 'sportmediiia':
            return 'mediiiasport'
        case 'sciencemediiia':
            return 'mediiiascience' 
        case 'concept':
            return 'conceptmediiia'
        default:
            return ctx
    }
}

export const useGetEmptyTabData = (disable?: boolean) => {
    const [resp, setResp] = useState<any>(undefined);
    const { i18n } = useTranslation();
    const [date] = useState(Date.now());
    const internalFilter = getEmptyTabData();

    const id = useMemo(() => !internalFilter ? getReplacedCtx() : '', [internalFilter])

    const disableRequest = useMemo(() => !!internalFilter, [internalFilter])
    const team = useTeam(id, date , i18n.language, disableRequest)

    useEffect(() => {
        if (internalFilter || team) {
            const finalFilter = internalFilter || team?.mainFilter;

            const tabFilter = team && team?.tabs?.[0]?.filter ? team?.tabs?.[0]?.filter : {}
            const tagIds = (team && team?.tabs?.[0]?.filter?.tagIds) ? { tagIds: team?.tabs?.[0]?.filter?.tagIds} : {};
            const contexts = (!!team?.tabs?.[0]?.filter?.contexts || !!finalFilter?.contexts ) ? { contexts: team?.tabs?.[0]?.filter?.contexts || team?.mainFilter?.contexts || finalFilter?.contexts } : {};
            const requiredTagIds = (team && team?.tabs?.[0]?.filter?.requiredTagIds) ? { requiredTagIds: team?.tabs?.[0]?.filter?.requiredTagIds} : {};
            const exceptedTagIds = (team && team?.tabs?.[0]?.filter?.exceptedTagIds) ? { exceptedTagIds: team?.tabs?.[0]?.filter?.exceptedTagIds} : {};
            
            const val = [ {
                filter: {
                    ...finalFilter,
                    ...tabFilter,
                    ...tagIds,
                    ...requiredTagIds,
                    ...exceptedTagIds,
                    ...contexts,
                    isLite: true,
                    projectStatus: finalFilter?.projectStatus?.length ? finalFilter?.projectStatus : [1],
                    ...(team?.contextName ? { requestContext: team?.contextName } : {}),
                }, 
                entityType: "projects",
                name: EMPTY_CONTENT_TAB,
                path: EMPTY_CONTENT_TAB 
            }]
            setResp(val)
        }
    }, [team, internalFilter])


    return [resp]
}import { AppTester, getCurrentContextName } from "supporting";
import { useTeam } from "./useTeam";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

export const EMPTY_CONTENT_TAB = 'EMPTY_CONTENT_TAB';

const TAB_DATA = {
    main: {
        contexts: ['hsedesign'],
        projectFilter: 21,
        projectStatus: [1,6],
        isLite: true,
        mainPage: true,
        limit: 20,
        isFilterReplaceTags: true,
        requestContext: 'design_main',
    },
    mainGeo: {
        projectFilter: 20,
        projectStatus: [1,6],
        isLite: true,
        mainPage: true,
        hasGeoPlaces: true,
        limit: 20,
        isFilterReplaceTags: true,
        requestContext: 'main_geo',
        tagIds: [
            '370972265d64431f9b9a8d1085474ea5',
            'c1e7071d86004544a497fd305b38550d',
            'b233488ebb364517b0acfdece809b3b6',
            '8ba964314ecd4d10b70693f5322605d1',
            '51069562a18341c2a968889727034174',
            '8db18d7413d74ab7a8e7aac29cfa3b25',
            '80f8067e3db745d3985740ccc30d3d5a',
            'd85cb74227a841998fa2aa18843ad35b',
            '977b986e706b46ff9e8b809c700a9c5d'
        ]
    },
    sound: {
        contexts: ['hsedesign'],
        projectFilter: 20,
        projectStatus: [1,6],
        isLite: true,
        mainPage: true,
        limit: 20,
        isFilterReplaceTags: true,
        globalTypes: ['student'],
        requestContext: 'sound_deziiign',
        tagIds: ['30e39c2e27fb430cbe541d94eb32d1ea']
    },
    hsedesign: {
        projectFilter: 20,
        isLite: true,
        limit: 20,
        contexts: ['hsedesign'],
        mainPage: true,
        projectStatus: 1,
        globalTypes: ['student', 'hsealumni'],
        requestContext: 'hsemain',
    },
    lms: {
        projectFilter: 20,
        isLite: true,
        contexts: ['hsecourses'],
        moderationTypes: 3,
        projectStatus: 1,
        requestContext: 'lms'
    },
    lmshse: {
        projectFilter: 3,
        isLite: true,
        limit: 20,
        contexts: ['educationalcourses', 'lmsonlinevaria'],
        moderationTypes: 3,
        globalTypes: ['student', 'hsealumni'],
        projectStatus: 1,
        requestContext: 'educationalcourses',
        lMSCourseType: 0

    },
    dafes: {
        projectFilter: 20,
        projectStatus: [1,6],
        isLite: true,
        mainPage: true,
        requiredTagIds: ['009c939ebdc34eb4801246557e49979f'],
        limit: 20,
        isFilterReplaceTags: true,
        requestContext: 'dafes',
        tagIds: [
            '1b374fc6d2aa4f3696a3558b324bca31',
            'ffa06d1b16b54abba2bbf6c8fb7eaf6d',
            '89412f173a904356beb8e25f74ff2b73',
            '2687fadaf0e048ed9925e56052f3010e',
            '0ea8c1fd2f6e49c3839c29fa10bc93b0',
            '9bbc6e63198244efb2f6e586898f8f84',
            '36e3fd69fede4f9fb4f84d1be90a9e91',
            'f0f14e99db1c4e25b889e87db45a73a0',
            '269d0812d0d84d4ca64faaea4f3b88cc',
            '8972f434446b43c49dd0db38f5e8e376',
            '47ae888ae5fe4343ad29999d04829b44',
            '52644f0d0d9d4a2ea47192e70310ec12',
            '55cc44daca804b979d067f9a59c56e00'
        ]
    },
    art: {
        projectFilter: 20,
        projectStatus: [1,6],
        isLite: true,
        mainPage: true,
        hascities: true,
        limit: 20,
        requestContext: 'art_geo',
        tagIds: [
            '140cdf7r1e3d8aq83e13qwedx14ba',
            '36eb670a9e774a3eba96d0a6e080d064',
            'df140c74barqwe1e3d883a590378812d77',
            'df140c74barqwe1e3d883aqe13dxzd2124dxs1',
            '5164b991a9d8469389175ceeb86d65b8',
            'cd7fbc104946470e872eb12d69343aeb',

        ],
        isContextIgnored: false
    },
    events: {
        hasGeotag: true,
        projectFilter: 20,
        projectStatus: [1,6],
        isLite: true,
        mainPage: true,
        limit: 20,
        isFilterReplaceTags: true,
        requestContext: 'events_geo',
        tagIds: [
            '00a68ac85a0e474985d37136a313f3bb',
            '3859c2a874cd4fcc8982995bc23fffda',
            'e3fdeca5f3aa47f485300ea15eee4e9b',
            'e1422025280f4aee8a6b69ecb78247e4',
            'c0c4895b14e642b4a0fbc471d0d3a35c',
            'd695b64fa924436197197838534cc829',
            '6a8a43782ea04a2192d0418809d3666a'
        ]
    },
    creative: {
        hasGeotag: true,
        projectFilter: 20,
        projectStatus: [1,6],
        isLite: true,
        mainPage: true,
        limit: 20,
        isFilterReplaceTags: true,
        requestContext: 'creative_geo',
        tagIds: ['dc762a78dac54369b91542bcbe86bb2a']
    },
    lmsmediiia: {
        projectFilter: 20,
        isLite: true,
        limit: 20,
        tagIds: [
            'd2d175d64b3b491c812f303fb6db6271'
        ],
        projectStatus: [1],
        requestContext: 'lms'
    },
    awards: {
        contexts: ['main_portfolio'],
        projectFilter: 21,
        projectStatus: [1,6],
        isLite: true,
        mainPage: true,
        limit: 20,
        isFilterReplaceTags: true,
        requestContext: 'main_portfolio',
    },
    game: {
        contexts: ['gamedeziiign'],
        projectFilter: 21,
        projectStatus: [1,6],
        isLite: true,
        mainPage: true,
        limit: 20,
        isFilterReplaceTags: true,
        requestContext: 'gamedeziiign',
    },
    exams: {
        contexts: ['exams2025'],
        projectFilter: 21,
        projectStatus: [1,6],
        isLite: true,
        mainPage: true,
        limit: 20,
        isFilterReplaceTags: true,
        requestContext: 'exams2025',
    },
    fashion: {
        contexts: ['hsedesign'],
        projectFilter: 21,
        projectStatus: [1,6],
        isLite: true,
        mainPage: true,
        limit: 20,
        isFilterReplaceTags: true,
        requestContext: 'fashion',
    },
    hsehh: {
        contexts: ['hsespace'],
        projectFilter: 21,
        projectStatus: [1,6],
        isLite: true,
        mainPage: true,
        limit: 20,
        isFilterReplaceTags: true,
        requestContext: 'hsespace',
    }
}

const getEmptyTabData = () => {
    if (getCurrentContextName() === 'main' && AppTester.isGeograffee()) return TAB_DATA['mainGeo']
    if (['hsesound']?.includes(getCurrentContextName())) return TAB_DATA['hsedesign']
    //@ts-ignore
    return TAB_DATA[getCurrentContextName() as keyof TAB_DATA]
}

const getReplacedCtx = () => {
    const ctx = getCurrentContextName();

    switch (ctx) {
        case 'books': 
            return 'books_deziiign'
        case 'pro':
            return 'prodeziiign'
        case 'academy':
            return 'creativecityacademy'
        case 'creativemediiia':
            return 'mediiiacreative';
        case 'historymediiia':
            return 'mediiiahistory'
        case 'transfermediiia':
            return 'mediiiatransfer'
        case 'profmediiia':
            return 'mediiiaprof'
        case 'cinemediiia':
            return 'mediiiacine'
        case 'aimediiia':
            return 'mediiiaai'
        case 'sportmediiia':
            return 'mediiiasport'
        case 'sciencemediiia':
            return 'mediiiascience' 
        case 'concept':
            return 'conceptmediiia'
        default:
            return ctx
    }
}

export const useGetEmptyTabData = (disable?: boolean) => {
    const [resp, setResp] = useState<any>(undefined);
    const { i18n } = useTranslation();
    const [date] = useState(Date.now());
    const internalFilter = getEmptyTabData();

    const id = useMemo(() => !internalFilter ? getReplacedCtx() : '', [internalFilter])

    const disableRequest = useMemo(() => !!internalFilter, [internalFilter])
    const team = useTeam(id, date , i18n.language, disableRequest)

    useEffect(() => {
        if (internalFilter || team) {
            const finalFilter = internalFilter || team?.mainFilter;

            const tabFilter = team && team?.tabs?.[0]?.filter ? team?.tabs?.[0]?.filter : {}
            const tagIds = (team && team?.tabs?.[0]?.filter?.tagIds) ? { tagIds: team?.tabs?.[0]?.filter?.tagIds} : {};
            const contexts = (!!team?.tabs?.[0]?.filter?.contexts || !!finalFilter?.contexts ) ? { contexts: team?.tabs?.[0]?.filter?.contexts || team?.mainFilter?.contexts || finalFilter?.contexts } : {};
            const requiredTagIds = (team && team?.tabs?.[0]?.filter?.requiredTagIds) ? { requiredTagIds: team?.tabs?.[0]?.filter?.requiredTagIds} : {};
            const exceptedTagIds = (team && team?.tabs?.[0]?.filter?.exceptedTagIds) ? { exceptedTagIds: team?.tabs?.[0]?.filter?.exceptedTagIds} : {};
            
            const val = [ {
                filter: {
                    ...finalFilter,
                    ...tabFilter,
                    ...tagIds,
                    ...requiredTagIds,
                    ...exceptedTagIds,
                    ...contexts,
                    isLite: true,
                    projectStatus: finalFilter?.projectStatus?.length ? finalFilter?.projectStatus : [1],
                    ...(team?.contextName ? { requestContext: team?.contextName } : {}),
                }, 
                entityType: "projects",
                name: EMPTY_CONTENT_TAB,
                path: EMPTY_CONTENT_TAB 
            }]
            setResp(val)
        }
    }, [team, internalFilter])


    return [resp]
}